import "../../FhTooltip.css";
import { computed, ref, openBlock, createBlock, withCtx, renderSlot, createElementBlock, createCommentVNode } from "vue";
import { a as shift, f as flip, o as offset, b as autoUpdate, F as FhOverlay } from "../../FhOverlay-Cm2BKH3f.js";
import { beaconToken } from "../utils.mjs";
import { PLACEMENT_ENUMS } from "./constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = {
  key: 0,
  class: "fh-tooltip"
};
const _sfc_main = {
  __name: "FhTooltip",
  props: {
    placement: {
      type: String,
      default: PLACEMENT_ENUMS.BOTTOM,
      validator: (value) => Object.values(PLACEMENT_ENUMS).includes(value)
    }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const floatingOptions = computed(() => ({
      middleware: [shift(), flip(), offset(beaconToken("--fh-space-xs").unitless)],
      placement: props.placement,
      whileElementsMounted: autoUpdate
    }));
    const overlay = ref(null);
    const close = () => {
      if (overlay.value) {
        overlay.value.close();
      }
    };
    const handleOverlayMouseOut = () => {
      close();
    };
    __expose({
      close
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhOverlay, {
        "open-on": ["mouseover", "focus"],
        "close-on": ["mouseout", "blur"],
        "close-on-click-outside": true,
        "floating-options": floatingOptions.value,
        "onContent:mouseout": handleOverlayMouseOut,
        ref_key: "overlay",
        ref: overlay,
        role: "tooltip"
      }, {
        invoker: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        default: withCtx(() => [
          _ctx.$slots.content ? (openBlock(), createElementBlock("div", _hoisted_1, [
            renderSlot(_ctx.$slots, "content", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["floating-options"]);
    };
  }
};
const FhTooltip = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b86fb223"]]);
export {
  FhTooltip as default
};
//# sourceMappingURL=FhTooltip.mjs.map
